// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BHcyuPcJ0PoMP4oW {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  gap: 12px;
}
.TuyOmKediB8lvL9G {
  color: #999;
  font-size: 13px;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/dataServiceRedirect/index.modules.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AACF;AAEA;EACE,WAAA;EACA,eAAA;EACA,eAAA;AAAF","sourcesContent":[".loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  gap: 12px;\n}\n\n.contactTip {\n  color: #999;\n  font-size: 13px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `BHcyuPcJ0PoMP4oW`,
	"contactTip": `TuyOmKediB8lvL9G`
};
export default ___CSS_LOADER_EXPORT___;
